import type { SelectorObject } from '../types';

export const usageProductVariantHeaderEditSelectors = {
  nameInput: 'usage-product-variant-header-edit-name-input',
  descriptionInput: 'usage-product-variant-header-edit-description-input',
} satisfies SelectorObject<'usage-product-variant-header-edit-'>;